import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconDescriptionPaper = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.6654 1.66699H4.9987C4.08203 1.66699 3.34036 2.41699 3.34036 3.33366L3.33203 16.667C3.33203 17.5837 4.0737 18.3337 4.99036 18.3337H14.9987C15.9154 18.3337 16.6654 17.5837 16.6654 16.667V6.66699L11.6654 1.66699ZM13.332 15.0003H6.66536V13.3337H13.332V15.0003ZM13.332 11.667H6.66536V10.0003H13.332V11.667ZM10.832 7.50033V2.91699L15.4154 7.50033H10.832Z",
		fill: "#00ABFF"
	})
});
export default SvgIconDescriptionPaper;
